<template>
  <main id="main-content" class="login-container">
    <header class="text-center">
      <SiteTitle />
    </header>

    <SiteContent :name="AUTH_LOGIN_NOTIFICATION" />
    <GuCard>
      <GuCardBody>
        <LoginForm />
      </GuCardBody>
      <GuCardFooter class="d-flex align-items-center gap-4">
        Don't have an account yet?
        <GuLink
          variant="info"
          outline
          class="ms-auto px-8"
          href="/UserRegistration/"
        >
          Sign Up
        </GuLink>
      </GuCardFooter>
    </GuCard>
    <SiteFooter />
  </main>
</template>

<script setup>
import LoginForm from '@shared/components/login/LoginForm.vue'
import SiteContent from '@shared/components/SiteContent.vue'
import { AUTH_LOGIN_NOTIFICATION } from '@shared/constants/siteContent'
import { GuCard, GuCardBody, GuCardFooter } from '@shared/gu-components/card'
import { GuLink } from '@shared/gu-components/link'

import SiteFooter from '../components/SiteFooter.vue'
import SiteTitle from '../components/SiteTitle.vue'
</script>
